export type TDocumentOwner = {
  Legal: number;
  Credit: number;
};

export const documentOwner: TDocumentOwner = {
  Legal: 1,
  Credit: 2,
};
